
(function (Drupal) {
  Drupal.behaviors.menuPrimary = {
    attach: function (context) {
      once('menuPrimaryClick', '.navigation--primary .dropbtn', context).forEach(function(el) {
        el.addEventListener('mousedown', function() {
          if (window.currentPrimaryTarget) {
            window.currentPrimaryTarget.classList.remove('active-menu')
          }
          window.currentPrimaryTarget = this.closest('.dropdown')
          window.currentPrimaryTarget.classList.add('active-menu')
        });
      });
      once('menuPrimaryOff', 'html', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          if (window.currentPrimaryTarget) {
            var dropdown =  e.target.closest('.dropdown')
            if (dropdown != window.currentPrimaryTarget) {
              window.currentPrimaryTarget.classList.remove('active-menu')
              window.currentPrimaryTarget = null
            }
          }
        });
      });
    }
  }
})(Drupal);
